function maskPhoneNumber(phoneNumber, fallbackValue = "") {
  if ((phoneNumber == null ? void 0 : phoneNumber.length) !== 10) {
    return phoneNumber || fallbackValue;
  }
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
}
function sanitizeNumberValue(value) {
  if (!value)
    return value;
  return value.replace(/[^0-9]/g, "");
}
const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
function formatErrorClassName(errorName) {
  return `${capitalize(errorName)}Error`;
}
function formatGraphQLErrorClassName(errorName) {
  return `${capitalize(errorName)}GraphQLError`;
}
export {
  formatGraphQLErrorClassName as a,
  formatErrorClassName as f,
  maskPhoneNumber as m,
  sanitizeNumberValue as s
};
//# sourceMappingURL=formatUtils-k3-nn42v.js.map
